import React, {useCallback, useEffect, useState} from "react";
import withDraw from "./hook/modal";
import ReactDOM from "react-dom";
import {ContainerMask} from "../../../components/mask";
import useStyles from "isomorphic-style-loader/useStyles";
import classes from "./style.module.scss";
import {useDispatch, useSelector} from "react-redux";
import {TOOGLE_UI_REPURCHASE_CARD,TOGGLE_UI_LOGIN} from "../../../../store/actions/ui";
import {useQuery} from "../../../hooks/common";
import {Iconfont} from "../../../components/icon/iconfont";
import {IMAGE_GEEKO_LTD} from "../../../../constants";
import Cache from "../../../../utils/cache";
import {FormattedMessage} from "react-intl";
import CountDown from "../../../components/count-down";

const CardModalItem = props => {
    useStyles(classes)
    const { onClose, modalData } = props;
    const [showOff, setShowOff] = useState(true);
    return <>
        <div className={classes.CardAlertModal}>
            <Iconfont onClick={onClose} className={classes.CloseModal}>&#xe69a;</Iconfont>
            {
                modalData?.font3 && <div className={classes.Font1} style={{ ...modalData?.font3?.style }}>
                    {modalData?.font3?.label}
                </div>
            }
            {
                modalData?.imageUrl && <div className={classes.CardModalImage}>
                    <img
                        src={`${IMAGE_GEEKO_LTD}${modalData?.imageUrl}`}
                        alt="cardImage"
                        style={{width:`${modalData?.imageWidth?modalData.imageWidth:'60%'}`}}
                    />
                </div>
            }
            <div style={{...modalData?.customerMadeStyle}}>
                {
                    modalData?.font1 && <div className={classes.Font1} style={{ ...modalData?.font1?.style }}>
                        {modalData?.font1?.label}
                    </div>
                }
                {
                    modalData?.font2 && <div className={classes.Font2} style={{ ...modalData?.font2?.style }}>
                        <span dangerouslySetInnerHTML={{__html:modalData?.font2?.label}}></span>
                    </div>
                }
                {
                    modalData?.font4 && <div className={classes.Font4} style={{ ...modalData?.font4?.style }}>
                        <span dangerouslySetInnerHTML={{__html:modalData?.font4?.label}}></span>
                    </div>
                }
                {
                    modalData?.font5 && <div className={classes.Font5} style={{ ...modalData?.font5?.style }}>
                        <span dangerouslySetInnerHTML={{__html:modalData?.font5?.label}}></span>
                    </div>
                }

                {
                    showOff && modalData?.showTimes > 1000 && <div className={classes.ExpireIn}>
                        <p><FormattedMessage id="expire_in" defaultMessage="Expire In" />:</p>
                        <CountDown
                            offset={modalData?.showTimes}
                            showLabel
                            showHour
                            callback={() =>setShowOff(false)}
                            numberStyle={{backgroundColor: '#222',color:'#ffffff',padding:'2px 2px 2px 4px',fontSize: '12px',fontFamily: 'Roboto-Medium'}}
                            labelStyle={{backgroundColor: '#222',color:'#ffffff',padding:'2px 4px 2px 0px',textTransform: 'uppercase',fontSize: '12px',fontFamily: 'Roboto-Medium'}}
                            dotStyle={{color:'#222',margin:'0 3px'}}
                        />
                    </div>
                }
                <div className={classes.ButtonContainer}>
                    {
                        modalData?.btn1 && <button onClick={modalData?.btn1?.callback} className={`${classes.Btn1} ${modalData?.btn1?.isUppercase?classes.TextUppercase:""}`}>{modalData?.btn1?.label}</button>
                    }

                    {
                        modalData?.btn2 && <button onClick={modalData?.btn2?.callback} className={`${classes.Btn2} ${modalData?.btn2?.isUppercase?classes.TextUppercase:""}`}>{modalData?.btn2?.label}</button>
                    }
                </div>
            </div>
        </div>
    </>
}
const CardModalSimpleItem = props => {
    useStyles(classes)
    const { onClose } = props;
    return <>
        <div className={classes.CardAlertModalSimple}>
            <Iconfont onClick={onClose} className={classes.CloseModal}>&#xe69a;</Iconfont>
            <div>
                <div className={classes.Congrats}>
                    <span>🎉Congrats!</span>
                </div>
                <div className={classes.lable1}>
                    <span>You've unlocked your exclusive VIP code</span>
                </div>
                <div className={classes.lable2}>
                    <span>CODE: ME40</span>
                </div>
                <div className={classes.content}>
                    <div className={classes.contentName} style={{paddingTop:'12px'}}>
                        <span>Step1: </span>
                    </div>
                    <div className={`${classes.contentValue} ${classes.DashedBox}` }>
                        <span>Add your favorite items to cart</span>
                    </div>
                    <div className={classes.contentName}>
                        <span>Step2: </span>
                    </div>
                    <div className={`${classes.contentValue} ${classes.DashedBox}`}>
                        <span>Apply code <span className={classes.couponName}>[ME40]</span> at checkout</span>
                    </div>
                    <div className={classes.contentName}>
                        <span>Step3: </span>
                    </div>
                    <div className={classes.contentValue } style={{paddingBottom:'42px'}}>
                        <span>Enjoy the savings!</span>
                    </div>
                </div>
            </div>
            <div className={classes.ButtonContainer}>
                {
                    <button onClick={onClose} className={`${classes.Btn2} ${classes.TextUppercase}`}>SHOP NOW</button>
                }
            </div>
        </div>
    </>
}
const Wrapped = withDraw(props => {
    return <React.Fragment>
        {
            <CardModalItem {...props}/>
        }
    </React.Fragment>
});
// const RepurchaseCard= props => {
//     return <React.Fragment>
//         {
//             <Wrapped {...props} />
//         }
//     </React.Fragment>
// }
const RepurchaseCard= props => {
    return <React.Fragment>
        {
            <CardModalSimpleItem {...props}/>
        }
    </React.Fragment>
}
export default props => {
    useStyles(classes);
    const ui = useSelector(state => state.ui)
    if (typeof window === 'undefined') {
        return null
    }
    const dispatch = useDispatch()
    const query = useQuery()
    let repurchaseGiftCardResultCode=query.repurchaseGiftCardResultCode
    // if(!repurchaseGiftCardResultCode){
    //     repurchaseGiftCardResultCode=Cache.get("repurchaseGiftCardResultCode")
    // }
    useEffect(() => {
        if(!!query.repurchaseGiftCard){
            dispatch({
                type: TOOGLE_UI_REPURCHASE_CARD,
                payload: true
            })
            if (window.GeekoSensors) {
                window.GeekoSensors.Track("REPURCHASE_CARD_POP", {

                })
            }
            // if(repurchaseGiftCardResultCode){
            //     dispatch({
            //         type: TOOGLE_UI_REPURCHASE_CARD,
            //         payload: true
            //     })
            // }else{
            //     dispatch({
            //         type: TOGGLE_UI_LOGIN,
            //         payload: {
            //             showLogin: true,
            //             eventType: "首页",
            //             redirectUrl: null,
            //             callBack: function () {
            //                 dispatch({
            //                     type: TOOGLE_UI_REPURCHASE_CARD,
            //                     payload: true
            //                 })
            //             }
            //         }
            //     })
            // }

        }
    }, [])
    const handleClose = () => {
        dispatch({type: TOOGLE_UI_REPURCHASE_CARD, payload: false})
    }
    // console.log("@repurchaseGiftCardResultCode",Cache.get("repurchaseGiftCardResultCode"))
    return <React.Fragment>
        {
            ui.showRepurchaseCard &&  ReactDOM.createPortal(<React.Fragment>
                <ContainerMask onClick={handleClose} style={{ backgroundColor: 'rgba(0,0,0,0.8)', zIndex: 5 }}>
                    <RepurchaseCard onClose={handleClose} repurchaseGiftCardResultCode={repurchaseGiftCardResultCode}/>
                </ContainerMask>
            </React.Fragment>, typeof document !== 'undefined' ? document.getElementById('root') : null)
        }
    </React.Fragment>
}